<template>

    <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      :page-size="msg.pageSize"
      :current-page="msg.page"
      :page-count="msg.total"
      :total="msg.total"
     >
    </el-pagination>

</template>

<script>
  export default {
    name: "pagination",
    props: ["msg"],
    methods: {
      handleCurrentChange(val) {
        this.$emit('refreshList',val);
      },
      handleSizeChange(val) {
        this.$emit('handleSizeChange',val);
      },
    }
  }
</script>

<style scoped>

  /*.page{*/
    /*text-align: right;*/
    /*margin: 20px auto 20px;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue